<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">派单</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">活动内容</div>
            <el-input v-model="edit_activityContentName" readonly ></el-input>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">实践站点</div>
            <el-input v-model="edit_practiceSiteName" readonly ></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" class="item">
            <div class="label">志愿队伍</div>
            <el-select v-model="edit_vt_code" filterable placeholder="请选择志愿队伍" style="width:100%">
              <el-option
                  v-for="item in edit_vt_arr"
                  :key="item.volunteerTeamCode"
                  :label="item.name"
                  :value="item.volunteerTeamCode">
              </el-option>
            </el-select>
          </el-col>
        </el-row>


      </div>
      <div class="modal-footer">
        <el-button @click.native="closeSelf">取消</el-button>
        <el-button :loading="loading"  type="primary" @click.native="confirm">确认</el-button>
      </div>
    </div>

  </div>
</template>


<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: 'Edit',
  props: [],
  data() {
    return {

      loading: false,

      edit_activityContentName:'',
      edit_practiceSiteName:'',

      edit_vt_arr:[],
      edit_vt_code:'',


      activityOrderCode:'',


    }
  },
  methods: {
    init(row){

      this.edit_activityContentName = row.activityContentName;
      this.edit_practiceSiteName = row.practiceSiteName;
      this.edit_vt_code = row.volunteerTeamCode;


      this.activityOrderCode = row.activityOrderCode;

      this.getList();

    },

    closeSelf() {
      this.loading= false
      this.$emit("closeEdit");
    },

    confirm(){

      if(this.edit_vt_code === ''){
        this.$message("请选择志愿队伍");
        return;
      }


      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'ActivityOrder/Pass',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          volunteerTeamCode:this.edit_vt_code,
          activityOrderCode:this.activityOrderCode,
        }
      }).then( (response)=> {
        //console.log(response)
        this.loading = false;
        if(response.data.error == 0){
          this.$emit("closeEdit");
          this.$emit("getList");
          this.$message('派单成功');
        }else{
          this.$message(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });

    },


    getList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'VolunteerTeam/List',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          applyStatus:2,
        }
      }).then( (response)=> {
        console.log(response);
        if(response.data.error == 0){
          this.edit_vt_arr = response.data.data.list;

        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },

  }
}
</script>

